/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AdminSuperuserStatusDataType, AdminUserStatusDataType, ForgotPasswdDataType } from './AdminUsersPage.types';

export const adminUserStatusDataInitialValues: AdminUserStatusDataType = {
  user: null,
  name: null,
  isModalOpened: false,
  isErrorModalOpened: false,
  errorMessage: '',
};

export const forgotPasswdDataInitialValues: ForgotPasswdDataType = {
  email: null,
  name: null,
  isModalOpened: false,
  isErrorModalOpened: false,
  isSuccess: false,
};

export const adminSuperuserStatusDataInitialValues: AdminSuperuserStatusDataType = {
  user: null,
  name: null,
  isModalOpened: false,
  isErrorModalOpened: false,
  errorMessage: '',
};
